import type { Host } from './types'

type TempAgentDefaults = {
  host_id: string | null
  harness_id: string | null
  ai_brain_model_id: string | null
  harness_name: string | null
} | null

// Whether this household can spawn a temp agent right now: a host is online
// with an agent harness, and the household's temp recipe (Household → Temp
// agents) is complete. One definition for every surface that spawns one — the
// "Temp Agent" button in the create sheet and @helper in chat — so they can't
// disagree about when it's possible.
export function tempAgentAvailability(hosts: Host[], defaults: TempAgentDefaults) {
  const agentsBlocked = !hosts.some((h) => h.online && (h.available_harness_ids?.length ?? 0) > 0)
  const harnessNeedsModel =
    defaults?.harness_name === 'claude-code' || defaults?.harness_name === 'codex'
  const hasDefaults = !!(
    defaults?.host_id &&
    defaults?.harness_id &&
    (!harnessNeedsModel || defaults?.ai_brain_model_id)
  )
  return { agentsBlocked, hasDefaults, canSpawnTemp: !agentsBlocked && hasDefaults }
}
